import React from "react";

function ArticleSlide() {
	return (
		<div>
			<h1>This is ArticleSlide</h1>
		</div>
	);
}

export default ArticleSlide;
